// extracted by mini-css-extract-plugin
export default {"callnotes":"CallNotes_callnotes__l8pq2","outer":"CallNotes_outer__dIcWN","inner":"CallNotes_inner__gKUgC","header":"CallNotes_header__aji4q","note":"CallNotes_note__QvYcs"};